import type React from "react";
import { Vendor } from "@client-shared/providers";
import { setOnboardingLayoutTestId } from "./onboarding-layout.utils";
import { UserNav } from "./user-nav";

interface OnboardingLayoutProps {
  readonly children: React.ReactNode;
  readonly contentWidth?: "default" | "wide";
  readonly testId?: string;
}

export function OnboardingLayout({ children, contentWidth = "default", testId }: OnboardingLayoutProps) {
  const contentWidthClass = contentWidth === "wide" ? "max-w-7xl" : "max-w-5xl";
  const [vendorState] = Vendor.useVendorContext();
  const vendorName = vendorState.currentVendor?.vendorName?.trim();

  return (
    <div data-testid={testId ?? setOnboardingLayoutTestId("container")} className="min-h-screen bg-[#FAF6F3]">
      <header data-testid={setOnboardingLayoutTestId("header")} className="border-b border-border-subtle bg-white flex px-5">
        <div className="container mx-auto px-6 py-4">{vendorName && <p className="text-lg font-semibold">{vendorName}</p>}</div>
        <UserNav />
      </header>
      <main data-testid={setOnboardingLayoutTestId("main")} className="container mx-auto px-6 py-12">
        <div data-testid={setOnboardingLayoutTestId("content")} className={`mx-auto ${contentWidthClass}`}>
          {children}
        </div>
      </main>
    </div>
  );
}
